export default __webpack_public_path__ + "static/media/hondaMotors.aa5e3a7a.png";